import {Component,ElementRef,EventEmitter,Input,OnInit, Output, ViewChild} from "@angular/core";
import { Subject } from "rxjs";
import { DataTableDirective } from "angular-datatables";
import { NgbModal, NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ImageCroppedEvent } from "ngx-image-cropper";
import { AngularEditorConfig } from "@kolkov/angular-editor";
import { HttpClient } from "@angular/common/http";
import { EncryptionService } from "src/app/_services/encryption.service";
import { AlertService, BlogService } from "src/app/_services";
import { Router } from "@angular/router";
import { MentorshipDashboardService } from "src/app/_services/mentorship-dashboard.service";
import { ThrowStmt } from "@angular/compiler";
import { ExcelService } from "src/app/_services/excel.service";
import * as moment from "moment";
declare const $: any;

  
  class DataTablesResponse {
    data: any[];
    draw: number;
    recordsFiltered: number;
    recordsTotal: number;
  }

@Component({
  selector: "app-all-mentors",
  templateUrl: "./all-mentors.component.html",
})


export class AllMentorsComponent implements OnInit{
   @ViewChild("datePicker", { static: false }) datePicker: ElementRef;
   startDate: any = '';
   endDate: any = '';
   start_date:any=''
   end_date:any=''

  @ViewChild(DataTableDirective, { static: false })
  dtElement: DataTableDirective;
  // dtOptions: DataTables.Settings = {};
  dtOptions: DataTables.Settings = {
    pagingType: "full_numbers",
    pageLength: 10,
    columnDefs: [
    ],
  };

  exportMentorList: any = [];
  fieldsIncludeExcel: any = [];

  exl: boolean = false;
  filterData = { status: "mentor" };
  dtTrigger = new Subject();
  allMentorsList: any = []; // Table Data list
  totalMentorsCount: any;
  modalReference: NgbActiveModal;
  modalCropper: NgbActiveModal;
  dateInvalid: boolean = false;
  today: string = '';
  isSubmitted = false;
  showloding = true;
  lodingImage = false;

  constructor(
    public router: Router,
    private http: HttpClient,
    private enc_dec: EncryptionService,
    private service :MentorshipDashboardService,
    private excelService: ExcelService,
  ) {

    const now = new Date();
    this.today = now.toISOString().split('T')[0]; 
  }

 
  ngOnInit() {
   window.scroll(0, 0);

       const strtDate = sessionStorage.getItem('startDate');
        const endDate = sessionStorage.getItem('endDate');
        this.startDate = strtDate ;
        this.endDate = endDate  ;

  const status = sessionStorage.getItem('mentorStatus');
  this.filterData.status = status ? status : 'mentor';

  this.getListing(); 
  this.mentorListing()
  // })  
}
    
onSearch() {
  this.isSubmitted = true;
  this.dateInvalid = false;

  if (!this.startDate || !this.endDate) {
    return;
  }

  const start = new Date(this.startDate);
  const end = new Date(this.endDate);

  if (start > end) {
    this.dateInvalid = true;
    return;
  }
  const table = $("#allmentors").DataTable();
  table.ajax.reload(null, false);
  this.mentorListing()

}  


formatDate(input: string): string {
  const date = new Date(input); // Parse input like "2024-06-12 11:19:19"
  
  const day = String(date.getDate()).padStart(2, '0');
  const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", 
                      "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  const month = monthNames[date.getMonth()];
  const year = date.getFullYear();

  let hours = date.getHours();
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const ampm = hours >= 12 ? 'PM' : 'AM';
  hours = hours % 12 || 12; // Convert to 12-hour format
  const hourStr = String(hours).padStart(2, '0');

  return `${day} ${month} ${year} ${hourStr}:${minutes} ${ampm}`;
}




  setFilterData(e: any) {
    this.filterData.status = e.target.value;
    this.mentorListing()
    const table = $("#allmentors").DataTable();
    table.search('').draw();
    table.ajax.reload(null, false);
  }



  mentorListing() {
    const data =  {
      "draw": 1,
      "start": 0,
      "length": 1,
      "order": [
          {
              "column": 0,
              "dir": "asc"
          }
      ],
          "search": {
          "value": "",
          "regex": false
      },
      "start_date":this.startDate,
      "end_date": this.endDate,
      "export": true,
      "type": this.filterData.status,
  }


    this.loadShow();
    this.service
      .dataExport(data)
      .pipe()
      .subscribe((res) => {
          this.exportMentorList = res["data"];
   if(this.filterData.status == 'mentor'){
   this.fieldsIncludeExcel = [
            "name",
            "status",
            "approved_rejected_by_name",
            "approved_rejected_date",
            "inactivated_by_name",
            "inactivated_date",
            "created_at",
      ];
   }
   else if(this.filterData.status == 'pending_mentor'){
    this.fieldsIncludeExcel = [
            "name",
            "status",
            "created_at",
      ];
   }
    
    else if(this.filterData.status == 'rejected_mentor'){
     this.fieldsIncludeExcel = [
            "name",
            "status",
            "approved_rejected_by_name",
            "approved_rejected_date",
            "inactivated_by_name",
            "inactivated_date",
            "created_at",
      ];
   }

    else if(this.filterData.status == 'approved_mentor'){
    this.fieldsIncludeExcel = [
            "name",
            "status",
            "approved_rejected_by_name",
            "approved_rejected_date",
            "inactivated_by_name",
            "inactivated_date",
            "created_at",
      ];
   }
        
          this.exl = true;
     
        this.loadHide();
      });
    }

   ngAfterViewInit(): void {
    this.dtTrigger.next();
    $('#allmentors').on('page.dt', function () {
      window.scrollTo({
        top: 0,
        behavior: 'smooth' 
      });
    });
  }

  onReset() {
   this.isSubmitted = false;
   this.startDate = ''
   this.endDate = ''
   const table = $("#allmentors").DataTable();
   table.ajax.reload(null, false);
   this.mentorListing()
  }
      
   

      onFilter(startDateInput?: string, endDateInput?: string) {
        const datePicker = $(this.datePicker.nativeElement);
        datePicker.attr("placeholder", "Select Date Range");
      
        let start: moment.Moment | null = null;
        let end: moment.Moment | null = null;
      
        if (startDateInput && endDateInput) {
          start = moment(startDateInput, "MM/DD/YYYY");
          end = moment(endDateInput, "MM/DD/YYYY");
      
          this.startDate = start.format("YYYY-MM-DD");
          this.endDate = end.format("YYYY-MM-DD");
        }
      
        datePicker.daterangepicker(
          {
            autoUpdateInput: !!start,
            showDropdowns: true,
            startDate: start || undefined,
            endDate: end || undefined,
            maxDate: moment(),
            locale: {
              format: "MM/DD/YYYY",
            },
          },
          (selectedStart, selectedEnd, label) => {
            this.startDate = selectedStart.format("YYYY-MM-DD");
            this.endDate = selectedEnd.format("YYYY-MM-DD");
      
            datePicker.val(
              selectedStart.format("MM/DD/YYYY") + " - " + selectedEnd.format("MM/DD/YYYY")
            );
      

            setTimeout(() => {
              this.mentorListing();
              const table = $("#allmentors").DataTable();
              table.ajax.reload(null, false);
              this.loadShow();
            }, 0);
          }
        );
      
        if (start && end) {
          datePicker.val(start.format("MM/DD/YYYY") + " - " + end.format("MM/DD/YYYY"));
        } else {
          datePicker.val('');
        }

      }
   
    
  onClear() {
   this.startDate = ''
   this.endDate = ''
   const table = $("#allmentors").DataTable();
   table.ajax.reload(null, false);
   this.mentorListing()
  }

  
  getListing() {
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
      serverSide: true,
      processing: true,
      ajax: (dataTablesParameters: any, callback) => {
        // Combine DataTables parameters with custom filters
        const requestPayload = {
          ...dataTablesParameters,
          type: this.filterData.status,
          export: false,
          start_date: this.startDate,
          end_date: this.endDate
        };
  
        const encryptedData = this.enc_dec.encrypt(JSON.stringify(requestPayload));
  
        this.http
          .post<DataTablesResponse>(
            '/api/metric-list',
            { req_data: encryptedData },
            {}
          )
          .subscribe((response: any) => {
            const output = this.enc_dec.decrypt(response.res_data);
            const resp = JSON.parse(output);
  
            this.allMentorsList = resp['data'];
            this.totalMentorsCount = resp['recordsFiltered'];
  
            callback({
              recordsTotal: resp['recordsTotal'],
              recordsFiltered: resp['recordsFiltered'],
              data: [], // Data already assigned above
            });
          });
        },
      columns: [
         { data: '' }, 
       { data: 'name' },
         { data: 'status' },
         { data: 'approved_rejected_by_name' },
         { data: 'approved_rejected_date' },
         { data: 'inactivated_by_name' },
         { data: 'inactivated_date' },
         { data: 'created_at' },
      ],
    };
  }

  blockTyping(event: KeyboardEvent) {
     event.preventDefault();  
  }


  exportToExcel() {
   if(this.filterData.status == 'mentor'){
    this.excelService.generateExcel(
      this.exportMentorList,
      this.fieldsIncludeExcel,
      "All Mentors"
    );
   }
   else if(this.filterData.status == 'pending_mentor'){
    this.excelService.generateExcel(
      this.exportMentorList,
      this.fieldsIncludeExcel,
      "Pending Mentors"
    );
   }
    
    else if(this.filterData.status == 'rejected_mentor'){
    this.excelService.generateExcel(
      this.exportMentorList,
      this.fieldsIncludeExcel,
      "Rejected Mentors"
    );
   }

    else if(this.filterData.status == 'approved_mentor'){
    this.excelService.generateExcel(
      this.exportMentorList,
      this.fieldsIncludeExcel,
      "Approved Mentors"
    );
   }
  }
  
  loadShow() {
    this.showloding = true;
    this.lodingImage = false;
  }

  loadHide() {
    this.showloding = false;
    this.lodingImage = true;
  }


 ngOnDestroy(): void {
  const table = $('#allmentors');
  table.off('page.dt');
  this.dtTrigger.unsubscribe();
}


  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next();
    });
  }

  
}
